// src/modules/assinaturas/estabelecimento/components/PeriodosEditModal.tsx
import React from 'react';
import moment from 'moment';
import { Modal } from '../../../../components/Modal';
import PriceInput from '../../../../components/inputs/Price';
import { SettingsRow, SettingsSection } from '../../../configuracoes/estabelecimento/Form/SettingsGroup';
import { EditState, formatCivilDateBR, formatCurrencyBRL } from '../utils/periodosUtils';
import { PAYMENT_METHOD_LABELS } from '../../../vendas/helpers';

type Props = {
    edit: EditState;
    loading: boolean;
    setEdit: React.Dispatch<React.SetStateAction<EditState>>;
    onClose: () => void;
    onSave: () => Promise<void> | void;
};

export default function PeriodosEditModal({ edit, loading, setEdit, onClose, onSave }: Props) {
    if (!edit.open) return null;

    return (
        <Modal
            title="Registrar pagamento"
            subTitle={
                edit.periodo
                    ? `${formatCivilDateBR(edit.periodo.inicio)} a ${formatCivilDateBR(edit.periodo.fim)}`
                    : undefined
            }
            onClose={onClose}
            desktopClassName="sm:!max-w-md"
        >
            <form
                className="estab-settings estab-settings--sheet space-y-4"
                onSubmit={(event) => {
                    event.preventDefault();
                    onSave();
                }}
            >
                <SettingsSection footer={`O período será marcado como pago. Valor previsto: ${formatCurrencyBRL(edit.periodo?.valorPrevisto ?? 0)}.`}>
                    <SettingsRow label="Valor pago">
                        <PriceInput
                            value={String(edit.valorPago ?? '')}
                            onChange={(e) =>
                                setEdit((current) => ({ ...current, valorPago: Number(e.target.value || 0) }))
                            }
                            placeholder="R$ 0,00"
                            label=""
                            className="estab-field w-full"
                        />
                    </SettingsRow>
                    <SettingsRow label="Forma de pagamento" htmlFor="periodo-payment-method">
                        <select
                            id="periodo-payment-method"
                            className="select estab-field"
                            value={edit.paymentMethod ?? 'PIX'}
                            onChange={(e) => setEdit((current) => ({ ...current, paymentMethod: e.target.value }))}
                        >
                            {Object.entries(PAYMENT_METHOD_LABELS).map(([value, label]) => (
                                <option key={value} value={value}>
                                    {label}
                                </option>
                            ))}
                        </select>
                    </SettingsRow>
                    <SettingsRow label="Data do pagamento" htmlFor="periodo-paid-at">
                        <input
                            id="periodo-paid-at"
                            type="date"
                            className="input estab-field"
                            value={edit.paidAt ? moment(edit.paidAt).format('YYYY-MM-DD') : ''}
                            onChange={(e) =>
                                setEdit((current) => ({
                                    ...current,
                                    // Meio-dia local: o fuso nao pode exibir o dia anterior.
                                    paidAt: e.target.value
                                        ? moment(e.target.value, 'YYYY-MM-DD').hour(12).toISOString()
                                        : null,
                                }))
                            }
                        />
                    </SettingsRow>
                </SettingsSection>

                <div className="estab-savebar gap-2">
                    <button
                        type="button"
                        className="btn btn-ghost flex-1 sm:flex-none sm:min-w-[7rem]"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary flex-1 sm:flex-none sm:min-w-[11rem]"
                        disabled={loading}
                    >
                        {loading && <span className="loading loading-spinner loading-sm"></span>}
                        Confirmar pagamento
                    </button>
                </div>
            </form>
        </Modal>
    );
}
